// @ts-nocheck
import * as React from "react";

const BigWave: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 443.1 46" preserveAspectRatio="none">
            <path d="M127.1 1C49.3 1 71.5 47 0 47h443.1V1z" fill="currentColor" transform="translate(0, 1)" />
        </svg>
    );
};

export default React.memo(BigWave);
